/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState = [];

const oexDisputeUpdateSlice = createSlice({
    name: 'oexDisputeUpdateForm',
    initialState,
    reducers: {
        setFormData: (state, action) => {
            return action.payload;
        },
        setDisputeUpdateData: (state, action) => {
            const { id, newData } = action.payload;

            const updatedFilteredItem = state.map((item) =>
                item.il_dispute_detail.id === id
                    ? { ...item, il_dispute_detail: { ...item.il_dispute_detail, ...newData } }
                    : item
            );
            return updatedFilteredItem;
        },
        addDispute: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteDispute: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((item) => item.id !== idToDelete);
        },
        resetFormData: (state) => {
            return initialState;
        },
    },
});

export const { setFormData, setDisputeUpdateData, addDispute, deleteDispute, resetFormData } =
    oexDisputeUpdateSlice.actions;
export default oexDisputeUpdateSlice.reducer;
